import React from "react";
import { Link } from "react-router-dom";
import { PageShell, PageHero, PageSection } from "../components/PageShell";
import { Button } from "../components/ui/button";

export default function Pricing() {
  return (
    <PageShell>
      <PageHero
        eyebrow="Pricing"
        title="Coming"
        highlight="soon."
        description="Plans are not open yet. The app is free to use with a registered device while we finish pricing."
      />

      <PageSection variant="content" className="text-center">
        <div className="mx-auto max-w-xl">
          <p className="text-muted-foreground leading-relaxed">
            If you want a board on a plot in the meantime, write to us.
          </p>
          <div className="mt-8 flex justify-center gap-3 flex-wrap">
            <Link to="/contact"><Button variant="accent" size="lg">Contact</Button></Link>
            <Link to="/signup"><Button variant="outline" size="lg">Create an account</Button></Link>
          </div>
        </div>
      </PageSection>
    </PageShell>
  );
}
